import { useSelector } from "react-redux";

import { useIsNewStackEnabled } from "#navigation/utils";
import { getActiveStore } from "src/redux/selectors/activeStore";

export const useIsBridgeEnabled = () => {
    const store = useSelector(getActiveStore);
    const isNewStackEnabled = useIsNewStackEnabled();
    if (!store) {
        console.error("no active store found");
        return false;
    }
    const isStoreBridgeDeployed = !!(store as any).enableBridge;
    return isNewStackEnabled && isStoreBridgeDeployed;
};
